var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { default as MuiSlider, } from '@mui/material/Slider';
import { useKey } from 'react-use';
import { styled } from '@mui/system';
export function Slider(_a) {
    var name = _a.name, _b = _a.defaultValue, defaultValue = _b === void 0 ? 0 : _b, triggerNext = _a.triggerNext, className = _a.className, _c = _a.step, step = _c === void 0 ? 1 : _c, BeforeIcon = _a.BeforeIcon, AfterIcon = _a.AfterIcon, required = _a.required, rules = _a.rules, label = _a.label, _d = _a.min, min = _d === void 0 ? 0 : _d, _e = _a.max, max = _e === void 0 ? 100 : _e, valueLabelFormat = _a.valueLabelFormat, _f = _a.valueLabelDisplay, valueLabelDisplay = _f === void 0 ? 'on' : _f, marks = _a.marks, sx = _a.sx, orientation = _a.orientation, props = __rest(_a, ["name", "defaultValue", "triggerNext", "className", "step", "BeforeIcon", "AfterIcon", "required", "rules", "label", "min", "max", "valueLabelFormat", "valueLabelDisplay", "marks", "sx", "orientation"]);
    var control = useFormContext().control;
    return (_jsx(Controller, { name: name, control: control, rules: rules, render: function (_a) {
            var _b = _a.field, onChange = _b.onChange, ref = _b.ref, value = _b.value;
            if (value === undefined)
                value = defaultValue || 0;
            var handleChange = function (event) {
                onChange(event);
            };
            var keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
            // its safe to use the hook in a loop because "keys" will never change
            // eslint-disable-next-line react-hooks/rules-of-hooks
            keys.forEach(function (key) { return useKey(key, function () { return handleChange(+key * step); }); });
            return (_jsxs(Wrapper, __assign({ className: className }, { children: [BeforeIcon !== null && BeforeIcon !== void 0 ? BeforeIcon : BeforeIcon, _jsx(StyledMuiSlider, __assign({ orientation: orientation, "aria-label": props['aria-label'] || name, value: value, step: step, marks: marks === null || marks === void 0 ? void 0 : marks(value), min: min, max: max, onChange: handleChange, defaultValue: defaultValue, valueLabelDisplay: valueLabelDisplay, valueLabelFormat: valueLabelFormat, sx: sx }, props)), AfterIcon !== null && AfterIcon !== void 0 ? AfterIcon : AfterIcon] })));
        } }));
}
export default Slider;
var Wrapper = styled(Stack)(function (_a) {
    var theme = _a.theme;
    return ({
        flexDirection: 'row',
        marginBottom: '1rem',
        alignItems: 'center',
    });
});
var StyledMuiSlider = styled(MuiSlider)(function (_a) {
    var theme = _a.theme;
    return ({
        '&:focus': {
            outline: "2px solid ".concat(theme.palette.primary.main),
        },
    });
});
